import api from "..";
export const fetchCountries = async () => {
    const url = `/country-groups/all-countries`;
    const result = await api.get(url);
    return result.data;
};
export const fetchTariffPlanTypes = async (params) => {
    const url = `/country-groups`;
    const result = await api.get(url, { params });
    return result.data;
};
export const createTariffPlanType = async (name) => {
    const url = `/country-groups`;
    const result = await api.post(url, name);
    return result.data;
};
export const updateTariffPlanTypes = async (data) => {
    const url = `/country-groups/${data.id}`;
    const result = await api.put(url, data);
    return result.data;
};
export const deleteTariffPlanType = async (id) => {
    const url = `/country-groups/${id}`;
    const result = await api.delete(url);
    return result.data;
};
export const fetchCountryGroupsByNetworkId = async (networkId, type, params) => {
    const url = `/country-groups/${networkId}/type/${type}`;
    const result = await api.get(url, { params });
    return result.data;
};
export const createNetworkGroup = async (data, sync = false) => {
    const url = `/country-groups/${data[0].networkId}?sync=${sync}`;
    const result = await api.post(url, data);
    return result.data;
};
export const updateSelectedCountries = async (networkId, data, sync = false) => {
    const url = `/country-groups/${networkId}?sync=${sync}`;
    const result = await api.post(url, data);
    return result.data;
};
export const updateNetworkGroupName = async (data, sync = false) => {
    const url = `/country-groups/${data.networkId}/group/${data.groupId}?sync=${sync}`;
    const result = await api.put(url, {
        name: data.newName,
        allNetworks: data.allNetworks,
    });
    return result.data;
};
export const deleteNetworkGroup = async (networkId, groupId, sync = false) => {
    const url = `/country-groups/${networkId}/group/${groupId}?sync=${sync}`;
    const result = await api.delete(url);
    return result.data;
};
export const syncNetwork = (networkId, countryGroupType) => {
    const url = `/country-groups/${networkId}/sync`;
    return api.post(url, { type: countryGroupType });
};
export const desyncNetwork = (networkId, countryGroupType) => {
    const url = `/country-groups/${networkId}/de-sync`;
    return api.post(url, { type: countryGroupType });
};
